var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/widgets/src/lib/select-token/select-token.element.ts
import { html as html6, LitElement as LitElement6 } from "lit";
import { customElement as customElement6, property as property3 } from "lit/decorators.js";
import { consume as consume5, provide } from "@lit/context";
import "@one-inch-community/ui-components/card";

// libs/widgets/src/lib/select-token/select-token.style.ts
import { css } from "lit";
var selectTokenStyle = css`

    :host {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }
    
    .empty {
        pointer-events: none;
    }

`;

// libs/widgets/src/lib/select-token/context.ts
import { createContext } from "@lit/context";
var selectTokenContext = createContext(Symbol("select token context"));

// libs/widgets/src/lib/select-token/select-token.context.ts
import {
  Subject,
  BehaviorSubject,
  combineLatest,
  switchMap,
  mergeMap,
  tap,
  startWith,
  debounceTime,
  distinctUntilChanged,
  defer
} from "rxjs";
var SelectTokenContext = class {
  constructor(tokenType, applicationContext, swapContext) {
    this.tokenType = tokenType;
    this.applicationContext = applicationContext;
    this.swapContext = swapContext;
    this.chainId$ = defer(() => this.applicationContext.connectWalletController.data.chainId$);
    this.connectedWalletAddress$ = defer(() => this.applicationContext.connectWalletController.data.activeAddress$);
    this.searchToken$ = new BehaviorSubject("");
    this.changeFavoriteTokenState$ = new Subject();
    this.searchInProgress$ = new BehaviorSubject(false);
    this.favoriteTokens$ = this.chainId$.pipe(
      mergeMap((chainId) => {
        if (chainId === null) return [];
        return this.applicationContext.tokenController.liveQuery(() => this.applicationContext.tokenController.getAllFavoriteTokenAddresses(chainId));
      })
    );
    this.tokenAddressList$ = combineLatest([
      this.chainId$,
      this.connectedWalletAddress$,
      this.searchToken$.pipe(
        debounceTime(300),
        startWith(""),
        distinctUntilChanged()
      )
    ]).pipe(
      switchMap(([chainId, address, searchToken]) => {
        if (chainId === null) return [];
        return this.applicationContext.tokenController.getSortedByPriorityAndBalanceTokenAddresses(chainId, searchToken, address ?? void 0);
      }),
      tap(() => this.searchInProgress$.next(false))
    );
  }
  async setFavoriteTokenState(chainId, address, state3) {
    await this.applicationContext.tokenController.setFavoriteState(chainId, address, state3);
    this.changeFavoriteTokenState$.next([chainId, address]);
  }
  setSearchToken(state3) {
    this.searchInProgress$.next(true);
    this.searchToken$.next(state3);
  }
  getSearchTokenValue() {
    return this.searchToken$.value;
  }
  onSelectToken(token) {
    this.swapContext.setToken(this.tokenType, token);
  }
};

// libs/widgets/src/lib/select-token/elements/search-token-input/search-token-input.element.ts
import { html, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// libs/widgets/src/lib/select-token/elements/search-token-input/search-token-input.style.ts
import { css as css2 } from "lit";
var searchTokenInputStyle = css2`

    .search-token-input-container {
        display: flex;
        background-color: var(--color-background-bg-secondary);
        height: 48px;
        border-radius: 12px;
        color: var(--color-content-content-tertiary);
        align-items: center;
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;
        gap: 8px;
        margin-top: 5px;
        transition: box-shadow .2s;
    }
    
    .search-token-input {
        border: none;
        background-color: transparent;
        height: 100%;
        width: 100%;
        outline: none;
        color: var(--color-content-content-primary);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    
    .loader {
        width: 24px;
        min-width: 24px;
        height: 24px;
        min-height: 24px;
        border-radius: 50%;
        border: 2px solid;
        border-bottom-color: var(--secondary);
        border-top-color: var(--secondary);
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    
    .search-token-input::placeholder {
        color: var(--color-content-content-secondary);
    }
    
    @media (hover: hover) {
        .search-token-input-container:hover {
            box-shadow: 0 0 0 1px var(--primary);
        }
    }
    
    .search-token-input-container__focused {
        box-shadow: 0 0 0 1px var(--primary);
    }

`;

// libs/widgets/src/lib/select-token/elements/search-token-input/search-token-input.element.ts
import "@one-inch-community/ui-components/icon";
import { sceneContext } from "@one-inch-community/ui-components/scene";
import { consume } from "@lit/context";
import { subscribe } from "@one-inch-community/core/lit";
import { of, tap as tap2 } from "rxjs";
import { when } from "lit/directives/when.js";
var SearchTokenInputElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.isFocused = false;
    this.searchInProgress = false;
  }
  render() {
    const classes = {
      "search-token-input-container": true,
      "search-token-input-container__focused": this.isFocused
    };
    return html`
      <div class="${classMap(classes)}">
        <inch-icon icon="search24"></inch-icon>
        <input
          id="search"
          autofocus
          autocomplete="off"
          maxlength="40"
          @input="${(event) => this.onChange(event)}"
          @focus="${() => this.isFocused = true}"
          @blur="${() => this.isFocused = false}"
          placeholder="Search token by name or address"
          class="search-token-input"
        >
        ${when(
      this.searchInProgress,
      () => html`<span class="loader"></span>`,
      () => html``
    )}
      </div>
    `;
  }
  async firstUpdated() {
    subscribe(this, [
      this.context?.searchInProgress$.pipe(tap2((state3) => this.searchInProgress = state3)) ?? of()
    ], { requestUpdate: false });
  }
  onChange(event) {
    const value = event.target.value;
    this.context?.setSearchToken(value);
  }
};
SearchTokenInputElement.tagName = "inch-search-token-input";
SearchTokenInputElement.styles = searchTokenInputStyle;
__decorateClass([
  state()
], SearchTokenInputElement.prototype, "isFocused", 2);
__decorateClass([
  state()
], SearchTokenInputElement.prototype, "searchInProgress", 2);
__decorateClass([
  consume({ context: sceneContext })
], SearchTokenInputElement.prototype, "sceneContext", 2);
__decorateClass([
  consume({ context: selectTokenContext })
], SearchTokenInputElement.prototype, "context", 2);
SearchTokenInputElement = __decorateClass([
  customElement(SearchTokenInputElement.tagName)
], SearchTokenInputElement);

// libs/widgets/src/lib/select-token/elements/token-list/token-list.element.ts
import { html as html4, LitElement as LitElement4 } from "lit";
import { customElement as customElement4, state as state2, property as property2 } from "lit/decorators.js";

// libs/widgets/src/lib/select-token/elements/token-list-item/token-list-item.element.ts
import { html as html3, LitElement as LitElement3 } from "lit";
import { customElement as customElement3, property } from "lit/decorators.js";
import { classMap as classMap2 } from "lit/directives/class-map.js";

// libs/widgets/src/lib/select-token/elements/token-list-item/token-list-item.style.ts
import { mobileMediaCSS } from "@one-inch-community/core/lit";
import { css as css3 } from "lit";
var tokenListItemStyle = css3`
    
    :host {
        height: 72px;
        width: 100%;
        outline: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }
    
    .item-container {
        padding: 12px 16px;
        display: flex;
        gap: 8px;
        align-items: center;
        cursor: pointer;
        border-radius: 16px;
        transition: background-color .2s;
    }

    .name-and-balance {
        display: flex;
        flex-direction: column;
        gap: 4px;
        max-width: 50%;
    }

    .name-and-balance .name {
        color: var(--color-content-content-primary);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .name-and-balance .balance {
        color: var(--color-content-content-secondary);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    
    .usd-balance {
        color: var(--color-content-content-primary);
        text-align: right;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        white-space: nowrap
    }

    .usd-balance {
        
    }
    
    .usd-balance-and-favorite-start {
        display: flex;
        align-items: center;
        margin-left: auto;
    }

    .usd-balance-and-favorite-start:dir(rtl) {
        margin-right: auto;
        margin-left: 0;
    }
    
    .is-favorite-start {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    @media (hover: hover) {
        .item-container:hover {
            background-color: var(--color-background-bg-secondary);
        }

        .item-container:not(.is-favorite-token) .usd-balance {
            transform: translateX(24px);
            transition: transform .2s;
        }

        .item-container:not(.is-favorite-token) .usd-balance:dir(rtl) {
            transform: translateX(-24px);
            transition: transform .2s;
        }

        .item-container:not(.is-favorite-token) .is-favorite-start {
            transform: scale(0);
            transition: transform .2s;
        }

        .item-container:hover .is-favorite-start {
            transform: scale(1);
        }

        .item-container:hover .usd-balance {
            transform: translateX(0);
        }

        .item-container:hover .usd-balance:dir(rtl) {
            transform: translateX(0);
        }
    }
    
    ${mobileMediaCSS(css3`
        .item-container {
            padding: 8px 8px;
        }
    `)}

    .item-container:active {
        background-color: var(--color-background-bg-secondary);
    }

`;

// libs/widgets/src/lib/select-token/elements/token-list-item/token-list-item.element.ts
import { formatUnits, isAddressEqual } from "viem";
import { Task } from "@lit/task";
import { formatNumber } from "@one-inch-community/core/formatters";
import "@one-inch-community/widgets/token-icon";
import "@one-inch-community/ui-components/icon";

// libs/widgets/src/lib/select-token/elements/token-list-stub-item/token-list-stub-tem.element.ts
import { html as html2, LitElement as LitElement2 } from "lit";
import { customElement as customElement2 } from "lit/decorators.js";

// libs/widgets/src/lib/select-token/elements/token-list-stub-item/token-list-stub-item.style.ts
import { mobileMediaCSS as mobileMediaCSS2 } from "@one-inch-community/core/lit";
import { css as css4 } from "lit";
var tokenListStubItemStyle = css4`
    
    :host {
        height: 72px;
        width: 100%;
    }
    
    .item-container {
        padding: 12px 16px;
        display: flex;
        gap: 8px;
        align-items: center;
        cursor: pointer;
        border-radius: 16px;
    }

    .name-and-balance {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    
    .stub-token-icon {
        min-width: 40px;
        min-height: 40px;
        border-radius: 50%;
        background-color: var(--color-background-bg-secondary);
    }

    .name-stub {
        background-color: var(--color-background-bg-secondary);
        height: 24px;
        width: 40%;
        border-radius: 8px;
    }

    .balance-stub {
        background-color: var(--color-background-bg-secondary);
        height: 20px;
        width: 30%;
        border-radius: 8px;
    }

    @keyframes stub-loader-animation {
        0%, 100% {
            filter: opacity(1);
        }
        50% {
            filter: opacity(0.5);
        }
    }

    ${mobileMediaCSS2(css4`
        .item-container {
            padding: 8px 8px;
        }
    `)}

`;

// libs/widgets/src/lib/select-token/elements/token-list-stub-item/token-list-stub-tem.element.ts
import { skeletonStyle } from "@one-inch-community/core/theme";
var TokenListStubTemElement = class extends LitElement2 {
  render() {
    return html2`
      <div class="item-container">
        <div class="stub-token-icon skeleton-token-icon"></div>
        <div class="name-and-balance">
          <span class="name-stub skeleton-name-and-balance"></span>
          <span class="balance-stub skeleton-name-and-balance"></span>
        </div>
      </div>
    `;
  }
};
TokenListStubTemElement.tagName = "inch-token-list-stub-item";
TokenListStubTemElement.styles = [
  tokenListStubItemStyle,
  skeletonStyle({ prefixName: "token-icon" }),
  skeletonStyle({ prefixName: "name-and-balance", animationDelay: ".7s" })
];
TokenListStubTemElement = __decorateClass([
  customElement2(TokenListStubTemElement.tagName)
], TokenListStubTemElement);

// libs/widgets/src/lib/select-token/elements/token-list-item/token-list-item.element.ts
import { subscribe as subscribe2, dispatchEvent } from "@one-inch-community/core/lit";
import { filter, merge, switchMap as switchMap2, timer } from "rxjs";
import { consume as consume2 } from "@lit/context";
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
var TokenListItemElement = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.isDestroy = false;
    this.preRenderTemplate = null;
    this.isFavorite = false;
    this.task = new Task(
      this,
      async ([chainId, tokenAddress, walletAddress, fastUpdate]) => {
        if (fastUpdate) {
          const result = this.task.value;
          if (result) return result;
        }
        if (!chainId || !tokenAddress) return [];
        if (this.isDestroy) throw new Error("");
        const token = await this.applicationContext.tokenController.getToken(chainId, tokenAddress);
        let balance = null;
        let balanceUsd = null;
        if (walletAddress && token) {
          balance = await this.applicationContext.tokenController.getTokenBalance(chainId, tokenAddress, walletAddress);
          const tokenPrice = await this.applicationContext.tokenController.getTokenUSDPrice(chainId, tokenAddress);
          const balanceFormatted = formatUnits(BigInt(balance?.amount ?? 0), token.decimals);
          balanceUsd = Number(balanceFormatted) * Number(tokenPrice);
        }
        const isFavoriteToken = token ? await this.applicationContext.tokenController.isFavoriteToken(chainId, token.address) : false;
        return [token, balance, balanceUsd, isFavoriteToken];
      },
      () => [this.chainId, this.tokenAddress, this.walletAddress, false]
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.isDestroy = true;
  }
  firstUpdated() {
    subscribe2(this, merge(
      timer(12e3),
      this.getTokenUpdateEmitter()
    ).pipe(
      switchMap2(() => this.task.run([this.chainId, this.tokenAddress, this.walletAddress, false]))
    ), { requestUpdate: false });
  }
  render() {
    return html3`
      ${this.task.render({
      complete: ([token, balance, balanceUsd, isFavoriteToken]) => this.getTokenView(token, balance, balanceUsd, isFavoriteToken),
      pending: () => {
        if (this.preRenderTemplate) return this.preRenderTemplate;
        return this.getStub();
      },
      error: () => {
        if (this.preRenderTemplate) return this.preRenderTemplate;
        return this.getStub();
      }
    })}
    `;
  }
  getTokenView(token, balance, balanceUsd, isFavoriteToken) {
    if (!token) {
      return this.getStub();
    }
    this.isFavorite = isFavoriteToken;
    let balanceFormat = "0";
    if (balance) {
      balanceFormat = formatNumber(formatUnits(BigInt(balance.amount), token.decimals), 6);
    }
    let balanceUsdFormat = "$0";
    if (balanceUsd) {
      balanceUsdFormat = "$" + formatNumber(balanceUsd.toString(), 2);
    }
    let startColor = { border: "var(--color-border-border-secondary)", body: "none" };
    if (this.isFavorite) {
      startColor = { border: "var(--color-core-orange-warning)", body: "var(--color-core-orange-warning)" };
    }
    const classes = {
      "item-container": true,
      "is-favorite-token": this.isFavorite
    };
    this.preRenderTemplate = html3`
      <div class="${classMap2(classes)}" @click="${(event) => {
      this.context?.onSelectToken(token);
      dispatchEvent(this, "backCard", null);
    }}">
        <inch-token-icon symbol="${token.symbol}" address="${token.address}" chainId="${token.chainId}"
                         size="40"></inch-token-icon>
        <div class="name-and-balance">
          <span class="name">${token.name}</span>
          <span class="balance">${balanceFormat} ${token.symbol}</span>
        </div>

        <div class="usd-balance-and-favorite-start">
          <span class="usd-balance">${balanceUsdFormat}</span>
          <inch-icon class="is-favorite-start" @click="${(event) => this.onMarkFavoriteToken(event, token)}"
                     icon="startDefault16" .props="${startColor}"></inch-icon>
        </div>
      </div>
    `;
    return this.preRenderTemplate;
  }
  async onMarkFavoriteToken(event, token) {
    event.preventDefault();
    event.stopPropagation();
    this.isFavorite = !this.isFavorite;
    await Promise.all([
      this.task.run([this.chainId, this.tokenAddress, this.walletAddress, true]),
      this.context?.setFavoriteTokenState(token.chainId, token.address, this.isFavorite)
    ]);
  }
  getTokenUpdateEmitter() {
    if (!this.context) throw new Error("");
    return this.context.changeFavoriteTokenState$.pipe(
      filter(([chainId, address]) => {
        const token = this.task?.value?.[0] ?? null;
        return token && token.chainId === chainId && isAddressEqual(token.address, address);
      })
    );
  }
  getStub() {
    return html3`
      <inch-token-list-stub-item></inch-token-list-stub-item>
    `;
  }
};
TokenListItemElement.tagName = "inch-token-list-item";
TokenListItemElement.styles = tokenListItemStyle;
__decorateClass([
  property({ type: String, attribute: true })
], TokenListItemElement.prototype, "tokenAddress", 2);
__decorateClass([
  property({ type: String, attribute: true })
], TokenListItemElement.prototype, "walletAddress", 2);
__decorateClass([
  property({ type: Number, attribute: true })
], TokenListItemElement.prototype, "chainId", 2);
__decorateClass([
  consume2({ context: selectTokenContext })
], TokenListItemElement.prototype, "context", 2);
__decorateClass([
  consume2({ context: ApplicationContextToken })
], TokenListItemElement.prototype, "applicationContext", 2);
TokenListItemElement = __decorateClass([
  customElement3(TokenListItemElement.tagName)
], TokenListItemElement);

// libs/widgets/src/lib/select-token/elements/token-list/token-list.element.ts
import "@one-inch-community/ui-components/icon";

// libs/widgets/src/lib/select-token/elements/token-list/token-list.style.ts
import { mobileMediaCSS as mobileMediaCSS3 } from "@one-inch-community/core/lit";
import { css as css5 } from "lit";
var tokenListStyle = css5`

    :host {
        height: 50vh;
        width: 100%;
        //position: relative;
    }
    
    .overlay-message {
        position: absolute;
        top: 35%;
        left: 0;
        width: 100%;
        text-align: center;
        color: var(--color-content-content-primary);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    
    ${mobileMediaCSS3(css5`
        :host {
            height: 100%;
            width: 100%;
        }
    `)}
`;

// libs/widgets/src/lib/select-token/elements/token-list/token-list.element.ts
import { consume as consume3 } from "@lit/context";
import { ChainId } from "@one-inch-community/models";
import { defer as defer2, shareReplay, tap as tap3 } from "rxjs";
import { observe, subscribe as subscribe3 } from "@one-inch-community/core/lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { sceneContext as sceneContext2 } from "@one-inch-community/ui-components/scene";
import "@one-inch-community/ui-components/scroll";
import { when as when2 } from "lit/directives/when.js";
import { getChainById, isChainId } from "@one-inch-community/sdk/chain";
var TokenListElement = class extends LitElement4 {
  constructor() {
    super(...arguments);
    this.chainId = null;
    this.walletAddress = null;
    this.isEmpty = false;
    this.addressList$ = defer2(() => this.getTokenAddressList()).pipe(
      tap3((list) => {
        this.isEmpty = list.length === 0;
        this.requestUpdate();
      }),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }
  render() {
    const searchValue = this.context?.getSearchTokenValue() ?? "";
    const searchValueExist = searchValue !== "";
    const unsupportedChainId = !isChainId(this.chainId);
    const chain = getChainById(this.chainId ?? ChainId.eth);
    return html4`
      ${when2(unsupportedChainId, () => html4`
        <div class="overlay-message">
          <h3>Unsupported chain</h3>
        </div>
      `)}
      ${when2(this.isEmpty && searchValueExist && !unsupportedChainId, () => html4`
        <div class="overlay-message">
          <inch-icon icon="emptySearch"></inch-icon>
          <h3>Token not found on ${chain.name} Network</h3>
          <span>Try changing your search query, or switch to another Network</span>
        </div>
      `)}
      <inch-scroll-view-virtualizer-consumer
        .header="${this.header}"
        .items=${observe(this.addressList$, this.getStubAddresses())}
        .keyFunction="${(address) => [this.chainId, this.walletAddress, address].join(":")}"
        .renderItem=${(address) => html4`
            <inch-token-list-item
              tokenAddress="${address}"
              walletAddress="${ifDefined(this.walletAddress ?? void 0)}"
              chainId="${ifDefined(this.chainId ?? void 0)}"
            ></inch-token-list-item>`}
      ></inch-scroll-view-virtualizer-consumer>
    `;
  }
  async firstUpdated() {
    subscribe3(this, [
      this.getConnectedWalletAddress().pipe(tap3((address) => this.walletAddress = address)),
      this.getChainId().pipe(tap3((chainId) => this.chainId = chainId)),
      this.addressList$
    ], { requestUpdate: false });
    subscribe3(this, [
      this.getFavoriteTokens()
    ]);
  }
  getTokenAddressList() {
    if (!this.context) throw new Error("");
    return this.context.tokenAddressList$;
  }
  getChainId() {
    if (!this.context) throw new Error("");
    return this.context.chainId$;
  }
  getFavoriteTokens() {
    if (!this.context) throw new Error("");
    return this.context.favoriteTokens$;
  }
  getConnectedWalletAddress() {
    if (!this.context) throw new Error("");
    return this.context.connectedWalletAddress$;
  }
  getStubAddresses() {
    return Array.from(Array(30)).map((_, index) => `0x${index.toString(16)}`);
  }
};
TokenListElement.tagName = "inch-token-list";
TokenListElement.styles = [
  tokenListStyle
];
__decorateClass([
  property2({ type: Object })
], TokenListElement.prototype, "header", 2);
__decorateClass([
  consume3({ context: selectTokenContext })
], TokenListElement.prototype, "context", 2);
__decorateClass([
  consume3({ context: sceneContext2 })
], TokenListElement.prototype, "sceneContext", 2);
__decorateClass([
  state2()
], TokenListElement.prototype, "chainId", 2);
__decorateClass([
  state2()
], TokenListElement.prototype, "walletAddress", 2);
__decorateClass([
  state2()
], TokenListElement.prototype, "isEmpty", 2);
TokenListElement = __decorateClass([
  customElement4(TokenListElement.tagName)
], TokenListElement);

// libs/widgets/src/lib/select-token/elements/favorite-tokens/favorite-tokens.element.ts
import { html as html5, LitElement as LitElement5 } from "lit";
import { customElement as customElement5 } from "lit/decorators.js";
import { when as when3 } from "lit/directives/when.js";
import { consume as consume4 } from "@lit/context";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/widgets/token-icon";
import "@one-inch-community/ui-components/icon";

// libs/widgets/src/lib/select-token/elements/favorite-tokens/favorite-tokens.styles.ts
import { css as css6 } from "lit";
var favoriteTokensStyles = css6`
    :host {
        display: flex;
        width: 100%;
        height: 60px;
    }
    
    :host(.empty) {
        height: 16px;
        padding-bottom: 0;
        margin-bottom: 0;
    }
    
    :host(.transition-host) {
        transition: height .2s, padding-bottom .2s, margin-bottom .2s;
    }
    
    :host(.remove-favorite-token-show) .remove-favorite-token {
        transform: scale(1) translate(0, 0);
    }
    
    .favorite-container-scroll {
        overflow-y: hidden;
        overflow-x: auto;
        touch-action: pan-x;
        position: relative;
        width: 100%;
        padding-top: 16px;
        padding-bottom: 8px;
        margin-bottom: 8px;
        height: 36px;
        scrollbar-width: none;
    }

    .favorite-container-scroll::-webkit-scrollbar {
        display: none;
    }
    
    .favorite-container {
        display: flex;
        gap: 12px;
        height: 36px;
        position: absolute;
    }
    
    .favorite-token-item-container {
        position: relative;
    }
    
    .remove-favorite-token {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--color-background-bg-secondary);
        z-index: 9;
        transition: transform .2s;
        transform: scale(0) translate(-16px, 16px);
        cursor: pointer;
        color: var(--color-content-content-primary);
    }
    
    @media (hover: hover) {
        .favorite-token-item-container:hover .remove-favorite-token {
            transform: scale(1) translate(0, 0);
        }
        .remove-favorite-token:hover {
            background-color: var(--secondary-hover);
        }
        .edit-favorite-token-list {
            display: none;
        }
    }
    
    

`;

// libs/widgets/src/lib/select-token/elements/favorite-tokens/favorite-tokens.element.ts
import {
  BehaviorSubject as BehaviorSubject2,
  combineLatest as combineLatest2,
  debounceTime as debounceTime2,
  defer as defer3,
  fromEvent,
  map,
  shareReplay as shareReplay2,
  startWith as startWith2,
  switchMap as switchMap3,
  tap as tap4
} from "rxjs";
import {
  observe as observe2,
  animationMap,
  subscribe as subscribe4,
  appendStyle,
  dispatchEvent as dispatchEvent2
} from "@one-inch-community/core/lit";
import { asyncFrame } from "@one-inch-community/core/async";
import { createRef, ref } from "lit/directives/ref.js";
import { ApplicationContextToken as ApplicationContextToken2 } from "@one-inch-community/core/application-context";
var animationOptions = {
  duration: 200,
  easing: "cubic-bezier(.2, .8, .2, 1)"
};
var FavoriteTokensElement = class extends LitElement5 {
  constructor() {
    super(...arguments);
    this.editAllMode$ = new BehaviorSubject2(false);
    this.scrollContainerRef = createRef();
    this.favoriteTokensAnimationMapController = new FavoriteTokensAnimationMapController(this);
    this.favoriteTokensView$ = combineLatest2([
      defer3(() => this.getFavoriteTokens()),
      defer3(() => this.getChainId())
    ]).pipe(
      debounceTime2(0),
      switchMap3(([tokens, chainId]) => {
        if (!chainId) return [];
        return this.applicationContext.tokenController.getTokenListSortedByPriority(chainId, tokens);
      }),
      startWith2([]),
      tap4((tokens) => {
        if (tokens.length && this.classList.contains("empty")) {
          this.classList.remove("empty");
        }
        if (!tokens.length && !this.classList.contains("empty")) {
          this.classList.add("empty");
        }
      }),
      tap4(() => {
        if (!this.classList.contains("transition-host")) {
          setTimeout(() => {
            this.classList.add("transition-host");
          }, 300);
        }
      }),
      map((tokens) => {
        if (tokens.length) {
          tokens.push(null);
        }
        return html5`
        <div ${ref(this.scrollContainerRef)} class="favorite-container-scroll">
          <div class="favorite-container">
            ${animationMap(tokens, this.favoriteTokensAnimationMapController)}
          </div>
        </div>
      `;
      }),
      shareReplay2({ bufferSize: 1, refCount: true })
    );
  }
  firstUpdated() {
    subscribe4(this, [
      this.editAllMode$.pipe(
        tap4((state3) => {
          state3 ? this.classList.add("remove-favorite-token-show") : this.classList.remove("remove-favorite-token-show");
        })
      ),
      fromEvent(this, "wheel").pipe(
        tap4((event) => {
          if (!this.scrollContainerRef.value) return;
          const element = this.scrollContainerRef.value;
          element.scrollLeft += event.deltaY;
        })
      )
    ], { requestUpdate: false });
  }
  render() {
    return html5`${observe2(this.favoriteTokensView$)}`;
  }
  getFavoriteTokens() {
    if (!this.context) throw new Error("");
    return this.context.favoriteTokens$;
  }
  getChainId() {
    if (!this.context) throw new Error("");
    return this.context.chainId$;
  }
  async onRemoveFavoriteToken(token, event) {
    event.stopPropagation();
    event.preventDefault();
    await this.context?.setFavoriteTokenState(token.chainId, token.address, false);
  }
};
FavoriteTokensElement.tagName = "inch-favorite-tokens";
FavoriteTokensElement.styles = [
  favoriteTokensStyles
];
__decorateClass([
  consume4({ context: selectTokenContext })
], FavoriteTokensElement.prototype, "context", 2);
__decorateClass([
  consume4({ context: ApplicationContextToken2 })
], FavoriteTokensElement.prototype, "applicationContext", 2);
FavoriteTokensElement = __decorateClass([
  customElement5(FavoriteTokensElement.tagName)
], FavoriteTokensElement);
var FavoriteTokensAnimationMapController = class {
  constructor(element) {
    this.element = element;
    this.direction = "horizontal";
    this.renderElements = /* @__PURE__ */ new Map();
    this.deleteElementsWidth = /* @__PURE__ */ new Map();
    this.moveElementsWidth = /* @__PURE__ */ new Map();
    this.gap = 8;
  }
  onKeyExtractor(token) {
    return token !== null ? "t" + token.address : "edit";
  }
  onTemplateBuilder(token) {
    return when3(
      token,
      (token2) => html5`
        <div class="favorite-token-item-container">
          <div class="remove-favorite-token"
               @click="${(event) => this.element.onRemoveFavoriteToken(token2, event)}">
            <inch-icon icon="cross8"></inch-icon>
          </div>
          <inch-button size="m" type="secondary" class="favorite-token-item"
                       @click="${() => {
        this.element.context?.onSelectToken(token2);
        dispatchEvent2(this.element, "backCard", null);
      }}">
            <inch-token-icon symbol="${token2.symbol}" address="${token2.address}"
                             chainId="${token2.chainId}"></inch-token-icon>
            <span>${token2.symbol}</span>
          </inch-button>
        </div>
      `,
      () => html5`
        <inch-button size="l" type="secondary" class="favorite-token-item edit-favorite-token-list"
                     @click="${() => this.element.editAllMode$.next(!this.element.editAllMode$.value)}">
          <inch-icon icon="edit24"></inch-icon>
        </inch-button>
      `
    );
  }
  async onBeforeRemoveAnimateItem(element) {
    await element.animate([
      { transform: "" },
      { transform: "translateX(-50%) scale(.3)", opacity: 0 }
    ], animationOptions).finished;
  }
  async onBeforeRenderAnimateItem(element) {
    appendStyle(element, {
      transform: "translateX(-100%)",
      opacity: "0"
    });
  }
  async onAfterRenderAnimateItem(element) {
    await element.animate([
      { transform: "translateX(-100%) scale(.3)", opacity: 0 },
      { transform: "translateX(0) scale(1)", opacity: 1 }
    ], animationOptions).finished;
    appendStyle(element, {
      transform: "",
      opacity: ""
    });
  }
  async onBeforeMoveAnimationItem(element, oldPosition, newPosition) {
    if (this.renderElements.has(oldPosition)) {
      return this.renderElements.get(oldPosition);
    }
    const offset = this.getOffsetMoveByMoveElements(oldPosition, newPosition);
    if (oldPosition < newPosition) {
      appendStyle(element, {
        transform: `translateX(${offset}px)`
      });
      return offset;
    }
    await element.animate([
      { transform: `translateX(0)` },
      { transform: `translateX(${offset}px)` }
    ], animationOptions).finished;
    return null;
  }
  async onAfterMoveAnimationItem(element, renderElementOfOffset) {
    if (renderElementOfOffset === null) return;
    let offset;
    if (typeof renderElementOfOffset === "number") {
      offset = renderElementOfOffset;
    } else {
      await asyncFrame();
      offset = renderElementOfOffset.clientWidth * -1 - this.gap;
    }
    await element.animate([
      { transform: `translateX(${offset}px)` },
      { transform: `translateX(0)` }
    ], animationOptions).finished;
    appendStyle(element, {
      transform: ""
    });
  }
  async onBeforeAnimation(container, renderElements, deleteElements, moveElements) {
    this.deleteElementsWidth.clear();
    this.renderElements.clear();
    this.moveElementsWidth.clear();
    deleteElements.forEach((element, index) => {
      this.deleteElementsWidth.set(index, element.clientWidth);
    });
    moveElements.forEach((element, index) => {
      this.moveElementsWidth.set(index.join(":"), element.clientWidth);
    });
    renderElements.forEach((element, index) => {
      this.renderElements.set(index, element);
    });
  }
  getOffsetMoveByMoveElements(oldPosition, newPosition) {
    let offset = 0;
    if (this.deleteElementsWidth.has(newPosition)) {
      offset = this.deleteElementsWidth.get(newPosition);
    } else if (oldPosition > newPosition) {
      this.deleteElementsWidth.forEach((width, index) => {
        if (index > oldPosition) return;
        offset = width;
      });
    } else {
      offset = this.moveElementsWidth.get([oldPosition - 1, newPosition - 1].join(":")) ?? 0;
    }
    return (offset + this.gap) * -1;
  }
};

// libs/widgets/src/lib/select-token/select-token.element.ts
import { subscribe as subscribe5 } from "@one-inch-community/core/lit";
import { tap as tap5 } from "rxjs";
import { classMap as classMap3 } from "lit/directives/class-map.js";
import { ApplicationContextToken as ApplicationContextToken3 } from "@one-inch-community/core/application-context";
import { SwapContextToken } from "@one-inch-community/sdk/swap";
var SelectTokenElement = class extends LitElement6 {
  constructor() {
    super(...arguments);
    this.isEmpty = true;
  }
  render() {
    const classes = {
      empty: this.isEmpty
    };
    this.initContext();
    return html6`
      <inch-token-list
        class="${classMap3(classes)}"
        .header="${() => html6`
          <div style="margin-left: 1px; margin-right: 1px; pointer-events: auto;">
            <inch-card-header backButton headerText="Select token"></inch-card-header>
            <inch-search-token-input></inch-search-token-input>
            <inch-favorite-tokens></inch-favorite-tokens>
          </div>
        `}"
      ></inch-token-list>
    `;
  }
  firstUpdated() {
    subscribe5(this, [
      this.getTokenAddressList().pipe(tap5((list) => this.isEmpty = list.length === 0))
    ]);
  }
  initContext() {
    if (this.selectTokenContext || !this.swapContext || !this.tokenType) return;
    this.selectTokenContext = new SelectTokenContext(
      this.tokenType,
      this.applicationContext,
      this.swapContext
    );
  }
  getTokenAddressList() {
    if (!this.selectTokenContext) throw new Error("");
    return this.selectTokenContext.tokenAddressList$;
  }
};
SelectTokenElement.tagName = "inch-select-token";
SelectTokenElement.styles = selectTokenStyle;
__decorateClass([
  property3({ type: String })
], SelectTokenElement.prototype, "tokenType", 2);
__decorateClass([
  consume5({ context: ApplicationContextToken3 })
], SelectTokenElement.prototype, "applicationContext", 2);
__decorateClass([
  consume5({ context: SwapContextToken, subscribe: true }),
  property3({ type: Object })
], SelectTokenElement.prototype, "swapContext", 2);
__decorateClass([
  provide({ context: selectTokenContext })
], SelectTokenElement.prototype, "selectTokenContext", 2);
SelectTokenElement = __decorateClass([
  customElement6(SelectTokenElement.tagName)
], SelectTokenElement);
export {
  SelectTokenElement
};
//# sourceMappingURL=index.esm.js.map
